import { BrowserModule, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { CommonModule } from "@angular/common";
import { NgModule, ApplicationRef } from '@angular/core';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { JwtInterceptor, ErrorInterceptor } from './helpers';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgChartsModule } from 'ng2-charts';
import { ResponseComponent } from './response/response.component';
import { SharedModule } from './shared.module';
import { MyHammerConfig } from '../../hammer.config';
// import { DeviceDetectorModule } from 'ngx-device-detector';
import { DataTablesModule } from 'angular-datatables';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireStorageModule } from '@angular/fire/compat/storage';


@NgModule({ declarations: [
        AppComponent,
        ResponseComponent
    ],
    bootstrap: [AppComponent], 
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        MatSidenavModule,
        MatListModule,
        FontAwesomeModule,
        SharedModule,
        NgChartsModule,
        DataTablesModule,
        AngularFireModule.initializeApp(environment.firebaseConfig),
        AngularFireStorageModule
        // DeviceDetectorModule.forRoot()
    ], providers: [
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        { provide: HAMMER_GESTURE_CONFIG, useClass: MyHammerConfig },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule {

}
